import { Fragment, useState } from "react";
import SEO from "../../components/seo";
import LayoutTwo from "../../layouts/LayoutTwo";
import { images } from "../../data/media/data";
import "../../../src/assets/css/media.css";
import HeroSlider from "../../wrappers/HeroSlider";

const Media = () => {
  const itemsPerPage = 6;
  const [currentPage, setCurrentPage] = useState(1);
  const [openAccordion, setOpenAccordion] = useState(0);

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentImages = images.slice(indexOfFirstItem, indexOfLastItem);

  const totalPages = Math.ceil(images.length / itemsPerPage);

  const handlePrevious = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };

  const handleNext = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  };

  const toggleAccordion = (index) => {
    setOpenAccordion(openAccordion === index ? null : index);
  };

  return (
    <div className="media_main">
      <Fragment>
        <SEO titleTemplate="Media" description="Media" />
        <LayoutTwo>
          <HeroSlider />
          <div className="media_con container">
            <div className="media_left_con">
              <div className="accordion">
                <div
                  className="accordion_title"
                  onClick={() => toggleAccordion(0)}
                >
                  <p>Event participation</p>
                  <span>{openAccordion === 0 ? "-" : "+"}</span>
                </div>
                <div
                  className={`accordion_details ${
                    openAccordion === 0 ? "opened" : ""
                  }`}
                >
                  <ul>
                    <li>Event 1</li>
                    <li>Event 2</li>
                    <li>Event 3</li>
                    <li>Event 4</li>
                    <li>Event 5</li>
                  </ul>
                </div>
              </div>
              <div className="accordion">
                <div
                  className="accordion_title"
                  onClick={() => toggleAccordion(1)}
                >
                  <p>Social activities</p>
                  <span>{openAccordion === 1 ? "-" : "+"}</span>
                </div>
                <div
                  className={`accordion_details ${
                    openAccordion === 1 ? "opened" : ""
                  }`}
                >
                  <ul>
                    <li>Event 1</li>
                    <li>Event 2</li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="media_right_con">
              {currentImages.map((img, index) => (
                <img src={img.image} alt="media" key={index} />
              ))}
              <div className="pagination">
                <button onClick={handlePrevious} disabled={currentPage === 1}>
                  {"<"} Prev
                </button>
                <button
                  onClick={handleNext}
                  disabled={currentPage === totalPages}
                >
                  Next {">"}
                </button>
              </div>
            </div>
          </div>
        </LayoutTwo>
      </Fragment>
    </div>
  );
};

export default Media;
